export default {
  None: 0,
  LightPanel: 1,
  HeavyPanel: 2,
  LightStructural: 3,
  HeavyStructural: 4
}